import { getDataFromServer } from '../../../util';

export class RiskIndicatorsModule {
  constructor(baseURL, httpHeaders) {
    this.baseURL = baseURL;
    this.httpHeaders = httpHeaders;
  }

  fetchRiskIndicatorGraph = async (payload) => {
    //riskIndicatorId not used as of now
    const { customerKey, clusterId, modelId } = payload;
    const params = {
      customerKey,
      clusterId,
      modelId
    };

    const url = `${this.baseURL}/customers/${customerKey}/riskIndicatorGraph`;
    const data = await getDataFromServer(url, this.httpHeaders, params);
    return data.map((graphData) => {
      const {
        profileDeviationGraph,
        peerComparisonGraph,
        importance,
        riskIndicatorId
      } = graphData;

      let selfComparisonCurrentValue = null;
      const selfComparisonDataPoints = profileDeviationGraph[
        'distribution'
      ].map((o) => {
        if (o.range === 'T0') {
          selfComparisonCurrentValue = {
            date: 'T0 (Current)',
            value: o.value !== 'nan' ? Number(o.value) : 0
          };

          return {
            date: 'T0 (Current)',
            value: o.value !== 'nan' ? Number(o.value) : 0
          };
        }

        return {
          date: o.range,
          value: o.value !== 'nan' ? Number(o.value) : 0
        };
      });

      let customerDotIndex = null;
      const peerComparisonDataPoints = peerComparisonGraph['distribution'].map(
        (o, idx) => {
          let range = 0;
          if (o.range !== 'nan') {
            const arrayOfY = o.range
              .replace('(', '')
              .replace(')', '')
              .split(',');
            let sumOfY = 0;
            arrayOfY.map((y) => {
              sumOfY += Number(y);
            });
            range = sumOfY / arrayOfY.length;

            if (arrayOfY.length === 1) {
              if (arrayOfY[0] === peerComparisonGraph['riValue']) {
                customerDotIndex = idx;
              }
            }

            if (arrayOfY.length > 1) {
              if (
                arrayOfY[1] >= peerComparisonGraph['riValue'] &&
                peerComparisonGraph['riValue'] >= arrayOfY[0]
              ) {
                customerDotIndex = idx;
              }
            }
          }
          return {
            count: o.range,
            value: o.value !== 'nan' ? Number(o.value) : 0
          };
        }
      );

      return {
        riskIndicatorId,
        importance: !isNaN(importance) ? Number(importance).toFixed(2) : 0,
        self_comparision: {
          mean: profileDeviationGraph['mean'],
          deviation: profileDeviationGraph['deviation'],
          current_value: selfComparisonCurrentValue,
          title: 'Value over period',
          data_points: selfComparisonDataPoints
        },
        peer_comparison: {
          mean: peerComparisonGraph['mean'],
          deviation: peerComparisonGraph['deviation'],
          percentile: `${Number(
            peerComparisonGraph['percentile'] * 100
          ).toFixed(2)}%`,
          title: 'Value distribution',
          current_value: {
            riValue: peerComparisonGraph['riValue']
          },
          data_points: peerComparisonDataPoints
        }
      };
    });
  };

  fetchListOfRiskIndicators = async () => {
    const url = `${this.baseURL}/riskIndicators`;
    return await getDataFromServer(url, this.httpHeaders);
  };
}
